import axios from 'axios';

import {ICampaignLink} from '@/shared/model/campaign-link.model';
import DataService from '@/core/base/service/data.service';
import {ICampaign} from '@/shared/model/campaign.model';
import {IFullCampaign} from "@/shared/model/full-campaign.model";

export default class CampaignLinkService extends DataService<ICampaignLink> {
    baseApiUrl: string = 'api/campaign-links';

    public findPublic(id: string): Promise<IFullCampaign> {
        return new Promise<ICampaign>((resolve, reject) => {
            axios
                .get(`api/shared/${id}`)
                .then(res => {
                    resolve(res.data);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    public findForCampaign(campaignId: number): Promise<ICampaignLink[]> {
        return new Promise<any>((resolve, reject) => {
            axios
                .get(`${this.baseApiUrl}/${campaignId}`)
                .then(res => resolve(res.data))
                .catch(err => {
                    reject(err);
                });
        });
    }

    public createForCampaign(campaignId: Number, link: ICampaignLink): Promise<ICampaignLink> {
        return new Promise<ICampaignLink>((resolve, reject) => {
            axios
                .post(`${this.baseApiUrl}/${campaignId}`, link)
                .then(res => {
                    resolve(res.data);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }
}
